import React from 'react';
import { useContent } from '@/providers/ContentProvider';
import { Language } from '@/types/types';
import { Flex, NativeSelect, Select, SelectProps, rem } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';
import IconChevronDown from '@/assets/icons/outline/chevron-down.svg?react';
import APP_CONFIG from '@/configs/appConfig';
import LANGUAGES from '@/configs/languages';
import styles from '../Navbar.module.scss';

const data = Object.entries(LANGUAGES).map(([lang, { name }]) => ({
	value: lang,
	label: name,
}));

const renderSelectOption: SelectProps['renderOption'] = ({ option }) => {
	const Flag = LANGUAGES[option.value as Language].flag;

	return (
		<Flex gap="sm">
			<Flag w={25} h={18.75} />
			{option.label}
		</Flex>
	);
};

export const LanguageSelect: React.FC = () => {
	const { language, setLanguage } = useContent();

	const mobileBreakpoint = useMediaQuery(
		`(max-width: ${rem(APP_CONFIG.BREAKPOINTS.MD)} )`
	);

	const SelectedFlag = LANGUAGES[language].flag;

	return mobileBreakpoint ? (
		<div className={styles.langContainer}>
			<div className={styles.nativeSelectWrapper}>
				<NativeSelect
					size="md"
					data={data}
					classNames={{
						input: styles.nativeSelectInput,
						section: styles.selectSection,
					}}
					onChange={(e) => setLanguage(e.currentTarget.value as Language)}
					value={language}
				/>
			</div>
		</div>
	) : (
		<Flex gap="sm">
			<SelectedFlag w={25} h={18.75} />
			<Select
				w={85}
				value={language}
				data={data}
				onChange={(lang) => setLanguage(lang as Language)}
				renderOption={renderSelectOption}
				rightSection={<IconChevronDown />}
				rightSectionWidth={20}
				comboboxProps={{
					position: 'bottom-start',
				}}
				classNames={{
					input: styles.selectInput,
					dropdown: styles.selectDropdown,
				}}
			/>
		</Flex>
	);
};
